/**
 * Block Utils
 * 
 * Utility functions for formatting block-related data.
 */

import { format } from "date-fns";
import { id as idLocale } from "date-fns/locale";

/**
 * Format a date string to date-time format with Indonesian locale
 */
export function formatDateTime(dateString: string | null | undefined): string {
  if (!dateString) return "-";
  try {
    return format(new Date(dateString), "dd MMM yyyy HH:mm", { locale: idLocale });
  } catch {
    return "-";
  }
}

